import api, { COURSE_LEVELS } from "./api";

export const fetchCourseLevels = async () => {
  return await api.get(`${COURSE_LEVELS}
  `);
};
